// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c77df214","239":"6b7dfd67","453":"28a4f7e4","455":"62154584"}[chunkId] + ".chunk.js";
};